<template>

    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-btn
        slot="activator"
        color="grey"
        dark
        flat icon
        title="Show Notifications"
        class="flex top-nav-link text--darken-2"
        :class="isMobile ? ' ' : 'ml-3 mr-4'"
      >
        <v-badge :overlap="true" bottom>
          <span slot="badge" overlap>{{notifications.length}}</span>
          <v-icon class="pt-1 "    :class="isMobile ? ' ' : 'pr-1 ml-3'">event_note</v-icon>
        </v-badge>
      </v-btn>

      <v-card>
        <v-card-title
          class="headline indigo lighten-1 white--text"
          primary-title
        >
          Notifications
        </v-card-title>
        <v-card-text>
          <ul class="pa-3 pl-4 list-style-type-none">
            <li v-for="(notification, key) in notifications" :key="key">
              <div v-html="notification.text"></div>
              <v-divider v-if="notifications.length > key +1 " class="my-2"></v-divider>
            </li>
          </ul>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="dialog = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  export default {
    name: "Notifications",
    watch: {
      showNotifications(newValue, oldValue) {
        this.dialog = true
      }
    },
    data() {
      return {
        notifications: [],
        dialog: true
      }
    },
    props: {
      isMobile: {
        type: Boolean,
      },
      showNotifications: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      getNotifications() {
          this.$http.get(this.$helper.apiUrl()+ '/content/notifications').then(resp => {
            const notificationsArr = resp.body
            notificationsArr.forEach(notification => {
              if(notification.activeFrom < this.$helper.getTimeStamp() && notification.activeTil > this.$helper.getTimeStamp()) {
                this.notifications.push(notification)
              }
            })
          })
      }
    },
    created() {
      this.getNotifications()
      this.dialog= this.showNotifications
      if (this.$ga.hasAnalytics()) {
        this.dialog = true
      }
    }
  }
</script>
<style>
  ul.list-style-type-none li{
    list-style-type: none;
  }
</style>

